import { useEffect } from 'react'

declare global {
    interface Window {
        fbq: (...args: any[]) => void
        _fbq: any
    }
}

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || ''

let initialized = false

/** Loads the Meta Pixel script and initializes fbq */
export const initMetaPixel = () => {
    if (initialized || !PIXEL_ID) return
    initialized = true

    // Standard Meta Pixel base code (injected at runtime after consent)
    ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return
        n = f.fbq = function () {
            n.callMethod
                ? n.callMethod.apply(n, arguments)
                : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
    })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
    )

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
}

/** Track a standard Meta Pixel event */
export const trackEvent = (event: string, params?: Record<string, any>) => {
    if (typeof window.fbq !== 'function') return
    window.fbq('track', event, params)
}

/** Track a custom Meta Pixel event */
export const trackCustomEvent = (
    event: string,
    params?: Record<string, any>
) => {
    if (typeof window.fbq !== 'function') return
    window.fbq('trackCustom', event, params)
}

/** Hook: initializes Meta Pixel once when analyticsAllowed becomes true */
export const useMetaPixel = (analyticsAllowed: boolean) => {
    useEffect(() => {
        if (analyticsAllowed) {
            initMetaPixel()
        }
    }, [analyticsAllowed])
}
